/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {

   /*---  Trigger click of filter for avibility true ---*/
  
    // if ( window.location.href.includes("collections/") && !window.location.href.includes("/products/")) {
    //   if (window.location.href.includes("filter.v.availability=1")==false){
    //      $('.apply_filter').trigger('click');
    //   }
    // }
  
/*---  Chnage Model PDP ---*/
  
  $('.Product_main_custom_slider').slick({
    arrows: true,
    asNavFor: ".product_thumbnail_custom_slider",
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow :'<button class="main-slider prev-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
    nextArrow :'<button class="main-slider next-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    infinite: false,
    responsive: [
    {
      breakpoint: 1008,
      settings: {
        dots: true,
        arrows:false
      }
    }
  ]
  });
  $('.product_thumbnail_custom_slider').slick({
    arrows: true,
    focusOnSelect: true,
    vertical: true,
    verticalSwiping:true,
    asNavFor: ".Product_main_custom_slider",
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow :'<button class="thumb-slider prev-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
    nextArrow :'<button class="thumb-slider next-arrow"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    infinite: false
  });
  var Changle_model = $('.model-title').length;
  if(Changle_model > 0){
 
   $(".Product_main_custom_slider").slick('slickFilter','.MODEL_1,.all_model');
   $(".product_thumbnail_custom_slider").slick('slickFilter','.MODEL_1,.all_model');
   $(".Product_main_custom_slider").slick('refresh');
   $(".product_thumbnail_custom_slider").slick('refresh');
  }
   
  Fancybox.bind("[data-fancybox]", {
    Thumbs: false,
    Carousel: {
    transition: 'slide',
    infinite: false, 
  },
  spinnerTpl : '<div class="my-custom-loader"><img src="https://cdn.shopify.com/s/files/1/0538/0485/9592/t/84/assets/loadinggifnew0.2.gif?v=7259401\202"></div>',
   
  });


  $('body').on('click','.model-title',function(e){
    e.preventDefault();
    if ($(window).width() < 768) {
      $('.Product__Wrapper .slick-dots li').eq(0).trigger('click');
    }
    $(this).hide();
    setTimeout(function(){
      $('.model-title').show();
    },500);
    
    var filterValue = $(this).attr('data-model');
    if (filterValue == 'MODEL_1') {
      $(this).attr('data-model','MODEL_2');
    } else {
      $(this).attr('data-model','MODEL_1');
    }
    
    var model_type = $(this).attr('data-model');
     $(".Product_main_custom_slider").slick('slickUnfilter');
     $(".product_thumbnail_custom_slider").slick('slickUnfilter');
    
    if(model_type == 'MODEL_1'){
      var selectedIndexThumb = $('.product_thumbnail_custom_slider .slick-active').attr('data-slick-index');
        $(".Product_main_custom_slider").slick('slickFilter','.MODEL_2,.all_model');
        $(".product_thumbnail_custom_slider").slick('slickFilter','.MODEL_2,.all_model');
        $(".Product_main_custom_slider").slick('slickGoTo', 0).slick('refresh');
        $(".product_thumbnail_custom_slider").slick('slickGoTo', 0).slick('refresh');
       
    }else if(model_type == 'MODEL_2'){
        $(".Product_main_custom_slider").slick('slickFilter','.MODEL_1,.all_model');
        $(".product_thumbnail_custom_slider").slick('slickFilter','.MODEL_1,.all_model');
        $(".Product_main_custom_slider").slick('slickGoTo', 0).slick('refresh');
        $(".product_thumbnail_custom_slider").slick('slickGoTo', 0).slick('refresh');
       
    }

});
  
  (function() {

  'use strict';
  const breakpoint = window.matchMedia( '(min-width:992px)' );
  let mySwiper;

  const breakpointChecker = function() {

    if ( breakpoint.matches === true ) {
	  if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
	  return;
      } else if ( breakpoint.matches === false ) {
        return enableSwiper();
          
      }

  };

  const enableSwiper = function() {
    mySwiper = new Swiper ('.swiper-container', {
      freeMode: true,
      loop: false,
      slidesPerView: 'auto',
      grabCursor: true,
      paginationClickable: true,
      scrollbar: {
        el: ".swiper-scrollbar"
      },
    });
  };
  breakpoint.addListener(breakpointChecker);
  breakpointChecker();
})();



  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  if (!$(".AnnouncementBar").isInViewport()) {
    $(".cm-filter-main.all-filter,.filter_overlay").addClass("scrolled");
  } else {
    $(".cm-filter-main.all-filter,.filter_overlay").removeClass("scrolled");
  }

  $(window).scroll(function () {
    if (!$(".AnnouncementBar").isInViewport()) {
      $(".cm-filter-main.all-filter,.filter_overlay").addClass("scrolled");
    } else {
      $(".cm-filter-main.all-filter,.filter_overlay").removeClass("scrolled");
    }
  });

  $("body").on(
    "click",
    ".CollectionMain .CollectionToolbar__Group .filter_options",
    function () {
      $(".cm-filter-main.all-filter,.filter_overlay").addClass("active");
    }
  );

  $("body").on(
    "click",
    ".filter_overlay,.cm-filter-main.all-filter .close_icon",
    function () {
      $(".cm-filter-main.all-filter,.filter_overlay").removeClass("active");
    }
  );

  $("body").on(
    "click",
    ".cm-filter-main.all-filter .tab-content .tab-link",
    function () {
      $(".cm-filter-main.all-filter .tab-content").removeClass("current");
      $(".cm-filter-main.all-filter .filter-select").slideUp();
      if (!$(this).next().is(":visible")) {
        $(this).next().slideDown();
        $(this).closest(".tab-content").addClass("current");
      }
    }
  );

  $("body").on(
    "click",
    ".product-item-custom .ProductItem__Wrapper .mobile_options_view",
    function (e) {
      e.preventDefault();
      $(this)
        .closest(".productImage_wp")
        .find(".grid_product_options,.pop_overlay")
        .addClass("active");
    }
  );
  $("body").on(
    "click",
    ".grid_product_options .close_btn,.pop_overlay.active",
    function () {
      $(".grid_product_options,.pop_overlay").removeClass("active");
    }
  );

  var currentVariant;

  function get_variant(form, getVariantData, fieldsets, event) {
    var options = [];
    var count = 0;
    if ($(window).width() > 767) {
      var BTS = ".BIS_trigger.mob_hide";
    } else {
      var BTS = ".BIS_trigger.desk_hide";
    }
    form.find(".product_option").each(function () {
      count++;
    });

    if (form.find(".Group_Radio:checked").length == count) {
      $.each(fieldsets, function (i, v) {
        var value = $(v).find("input[type='radio']:checked").val();
        options.push(value);
      });
      //       console.log(options);
      $.each(getVariantData, function (i, variant) {
        var lll = 0;
        $.each(variant.options, function (index, option) {
          if (options[index] !== option) {
            lll = 1;
          }
        });
        if (lll == 0) {
          currentVariant = variant;
        }
      });

      var id = currentVariant.id;
      form.find('[name="id"]').val(id).trigger("change");

      if (currentVariant.available) {
        form.find(BTS).attr("data-variant-id", id).hide();
        form
          .find(".add_tocart_btn")
          .text("Add to cart")
          .removeAttr("disabled", "disabled")
          .css({ background: "#000", color: "#fff" });
        if ($(window).width() < 767) {
          form.find(".add_tocart_btn").show();
        }
        if ($(window).width() > 767) {
          setTimeout(function () {
            form.find(".add_tocart_btn").trigger("click");
          }, 100);
        }
      } else {
        form.find(BTS).attr("data-variant-id", id).show();
        form.find(".add_tocart_btn").hide();
      }
    }
  }

  $("body").on(
    "change",
    ".product-item-custom .product_option .Group_Radio",
    function (event) {
      var form = $(this).closest("form");
      var getVariantData = JSON.parse(form.find(".product_var").text());
      var fieldsets = form.find(".product_option").toArray();
      get_variant(form, getVariantData, fieldsets, event);
    }
  );

  $("body").on("click", ".mobile_options_view", function () {
    if ($(window).width() < 767) {
      var form = $(this).parents(".ProductItem__Wrapper").find("form");
      var getVariantData = JSON.parse(form.find(".product_var").text());
      var fieldsets = form.find(".product_option").toArray();
      get_variant(form, getVariantData, fieldsets, event);
    }
  });

  $("body").on(
    "click",
    ".product-item-custom .add_tocart_btn",
    function (event) {
      $('body').removeClass('overflow-poup');
      $('.pop_overlay').removeClass('active'); 
      var form = $(this).closest("form");
      var btntext = $(this).text();
      $(this).text("Adding...");
      if ($(this).hasClass("single_option")) {
        var id = form.find('[name="id"]').val();
      } else {
        var id = currentVariant.id;
      }
      var cnt = 0;
      form.find(".product_option").each(function () {
        cnt++;
      });

      //       console.log(form.find('.Group_Radio:checked').length,count);
      if (form.find(".Group_Radio:checked").length == cnt) {
        fetch(window.routes.cartAddUrl + ".js", {
          body: JSON.stringify({ id: id, quantity: 1 }),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
          },
        }).then(function (response) {
          document.documentElement.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                variant: currentVariant,
                quantity: 1,
              },
            })
          );
          $(this).text(btntext);
          $(".grid_product_options,.pop_overlay").removeClass("active");
          // form.find(".ProductItem__ColorSwatchItem").each(function () {
          //   if (!$(this).hasClass("ProductItem_color_one_item")) {
          //     console.log("--");
          //     $(this).find("input:checked").prop("checked", false);
          //   }
          // });
        });
      }
    }
  );

  if (window.location.href.indexOf("checkouts") > -1) {
  }else{
    localStorage.removeItem("notes-cs");
  }

/*---  Match It With Slick Strat ---*/

  $('.product-looks-wrraper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    draggable:false,
    adaptiveHeight: true,
    swipe:false, 
    asNavFor: '.looks-index-wrrap'
  });

  $('.looks-index-wrrap').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    draggable:false,
    swipe:false, 
    asNavFor: '.product-looks-wrraper',
    arrow:false 
  });
  
  $('.MatchIt__Slider').on('init', function(event, slick){
      $('.look-inner .Image__Loader').removeClass('default');
  });
  $('.MatchIt__Slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    speed: 1000,
    autoplaySpeed: 1200,
    infinite: true,
    cssEase: 'linear',
    responsive: [
    {
      breakpoint: 768,
      settings: {
        dots: true
      }
    }
  ]
});

  function slickPause() {
	$('.MatchIt__Slider').slick('slickPause');
  }

slickPause();

$('.MatchIt__Slider').mouseover(function() {
	$(this).parents('.ProductItem__Wrapper').find('.MatchIt__Slider').slick('slickPlay');   	
});
$('.MatchIt__Slider').mouseout(function() {
	slickPause();
});  

  
  $(document).on('click','.match-it-with',function(){
    var height_val = $('.Header__Wrapper').height();
    $('html, body').animate({
        'scrollTop': $("#shopify-section-match-it-with").position().top - height_val
    },1000);
});

    $('body').on('click','.option-view',function(e){
      e.preventDefault();
       if($(window).width() < 767){
           var form = $(this).parents('.ProductItem__Wrapper').find('form');
           var getVariantData = JSON.parse(form.find('.product_var').text());
           var fieldsets = form.find('.product_option').toArray();
           get_variant(form,getVariantData,fieldsets,event);
        }
       $('.look-inner .grid_product_options,.pop_overlay').removeClass('active');
       $(this).closest('.productImage_wp').find('.grid_product_options,.pop_overlay').addClass('active');
       $('body').addClass('overflow-poup');
    });
    $('body').on('click','.look-inner .close_btn',function(e){
       e.preventDefault();
       $('body').removeClass('overflow-poup');
    });
    $('body').on('click','.look-inner .pop_overlay',function(e){
       e.preventDefault();
       $(this).removeClass('active');
       $('body').removeClass('overflow-poup');
    });
    
    $(".open_popup").click(function () {
     $(this).parents("body").find(".popup_body").addClass("popup_body_show");
    });
    $(".popup_close").click(function () {
     $(".popup_body").removeClass("popup_body_show");
    });
    $(".popup_back").click(function () {
     $(".popup_body").removeClass("popup_body_show");
    });

   /*---  Collection Page load-more ( hide/show ) ---*/
  $('body').on('click','.loader-icon',function(){
    $(this).hide();
    $('.loading-icon').show();
  });

  //  25-01-2024 js Start [Login Page] 
        const togglePassword = document.querySelector("#togglePassword");
        const password = document.querySelector("#password");

        togglePassword.addEventListener("click", function () {
            // toggle the type attribute
            const type = password.getAttribute("type") === "password" ? "text" : "password";
            password.setAttribute("type", type);

            // toggle the icon class
            this.classList.toggle("bi-eye-slash");
            this.classList.toggle("bi-eye");
        });
 //  25-01-2024 js End [Login Page] 
  
});
